module.exports = __webpack_public_path__ + "img/point.c023171a.png";